<template>
  <div class="">
    <div class="container left">
      <a class="link" href="https://hossa.gda.pl"
        ><svg class="icon icon-reply"><use xlink:href="#icon-reply"></use></svg>
        Wróć do serwisu</a
      ><router-link
        v-if="authenticated"
        to="/login"
        v-on:click.native="logout()"
        replace
        class="button"
        >Wyloguj się</router-link
      >
    </div>
    <div class="flex container">
      <div class="col col6">
        <loginForm />
      </div>
      <div class="col col6">
        <rightBox />
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
  // @ is an alias to /src
  import loginForm from "@/components/loginForm.vue";
  import Footer from "@/components/footer.vue";
  import rightBox from "@/components/rightBox.vue";
  export default {
    name: "Home",
    components: {
      loginForm,
      Footer,
      rightBox
    },
    data() {
      return {
        authenticated: ""
      };
    },
    watch: {
      authenticated: function(val) {
        alert(val);
        this.authenticated = this.$parent.authenticated;
      }
    },
    mounted() {
      //   console.log("formHome", this.$parent.authenticated);
    },
    methods: {
      logout() {
        this.$parent.authenticated = false;
      }
    }
  };
</script>
<style lang="scss"></style>
